import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';


@Pipe({
  name: 'dateAgo',
  pure: false,
})
export class DateAgoPipe implements PipeTransform {

  transform(
    value: Date | string | number | null | undefined,
  ): string {
    if (value == null || value === '' || value !== value) {
      return 'No data';
    }

    return moment(value).fromNow();
  }

}
